<div class="user-edit-container">
  <div class="page-header">
    <button routerLink="/admin/users" class="back-button">
      ← {{ backText }}
    </button>
    <h1>{{ isEditMode ? editTitleText : titleText }}</h1>
  </div>

  <div *ngIf="error" class="error-message">
    {{ error }}
  </div>

  <div *ngIf="loading" class="loading-message">
    {{ loadingText }}
  </div>

  <form [formGroup]="userForm" (ngSubmit)="onSubmit()" *ngIf="!loading" class="user-form">
    <div class="form-section">
      <div class="form-group">
        <label for="fullName">
          {{ nameLabel }} <span class="required">*</span>
        </label>
        <input
          type="text"
          id="fullName"
          formControlName="fullName"
          class="form-input"
          [class.error]="userForm.get('fullName')?.invalid && userForm.get('fullName')?.touched"
        />
        <div *ngIf="userForm.get('fullName')?.invalid && userForm.get('fullName')?.touched" class="error-text">
          {{ getFieldError('fullName') }}
        </div>
      </div>

      <div class="form-group">
        <label for="email">
          {{ emailLabel }} <span class="required">*</span>
        </label>
        <input
          type="email"
          id="email"
          formControlName="email"
          class="form-input"
          [class.error]="userForm.get('email')?.invalid && userForm.get('email')?.touched"
        />
        <div *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched" class="error-text">
          {{ getFieldError('email') }}
        </div>
      </div>

      <div class="form-group">
        <label for="phone">{{ phoneLabel }}</label>
        <input
          type="tel"
          id="phone"
          formControlName="phone"
          class="form-input"
        />
      </div>

      <div class="form-group">
        <label for="roleId">
          {{ roleLabel }} <span class="required">*</span>
        </label>
        <select
          id="roleId"
          formControlName="roleId"
          class="form-input"
          [class.error]="userForm.get('roleId')?.invalid && userForm.get('roleId')?.touched"
        >
          <option value="">{{ selectRoleText }}</option>
          <option *ngFor="let role of roles" [value]="role.id">
            {{ role.name }}
          </option>
        </select>
        <div *ngIf="userForm.get('roleId')?.invalid && userForm.get('roleId')?.touched" class="error-text">
          {{ getFieldError('roleId') }}
        </div>
      </div>

      <div class="form-group">
        <label for="password">
          {{ passwordLabel }}
          <span *ngIf="isEditMode" class="optional">({{ passwordPlaceholder }})</span>
          <span *ngIf="!isEditMode" class="required">*</span>
        </label>
        <input
          type="password"
          id="password"
          formControlName="password"
          class="form-input"
          [class.error]="userForm.get('password')?.invalid && userForm.get('password')?.touched"
        />
        <div *ngIf="userForm.get('password')?.invalid && userForm.get('password')?.touched" class="error-text">
          {{ getFieldError('password') }}
        </div>
      </div>

      <div class="form-group">
        <label for="comment">{{ commentLabel }}</label>
        <textarea
          id="comment"
          formControlName="comment"
          class="form-input"
          rows="4"
        ></textarea>
      </div>
    </div>

    <div class="form-actions">
      <button
        type="button"
        routerLink="/admin/users"
        class="cancel-button"
        [disabled]="submitting"
      >
        {{ cancelText }}
      </button>
      <button
        type="submit"
        class="submit-button"
        [disabled]="userForm.invalid || submitting"
      >
        {{ submitting ? (isEditMode ? editSubmittingText : submittingText) : (isEditMode ? editSubmitText : submitText) }}
      </button>
    </div>
  </form>
</div>
